import React from 'react';
import AlertMessage from '../../components/alerts';
import LeagueTableMain from '../../components/leaguetable';
import TopHeader from '../../components/header';
import LeftPanel from "../../components/leftpanel";

const LeagueTable = () => {

    return (

        <div id="container">
            <TopHeader />
            <div className="sidebar-mini">
                <LeftPanel />
                <div id="message-container">
                    <AlertMessage />
                </div>
                <LeagueTableMain />
            </div>
        </div>
    );
}

export default LeagueTable;